import React, { memo } from 'react';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

export const ArrowBack = memo((props) => <ChevronLeftIcon {...props} />);
